<div
	class="absolute top-0 left-0 right-0 bottom-0 z-dropdown-backdrop print:hidden pointer-events-none"
	[@dropdownAnimation]="open() ? 'open' : 'closed'"
	[id]="id()"
>
	<div
		class="bg-[var(--color-secondary-000)] border-secondary-300 border rounded box-border -mt-2 min-h-8 min-w-40 overflow-y-hidden absolute z-dropdown-backdrop pointer-events-auto"
		[ngStyle]="styles()"
		data-dropdown="true"
		#dropdown
	>
		<ng-container *ngTemplateOutlet="template()"></ng-container>
	</div>
</div>
